<template>
  <v-card>
    <v-card-subtitle>{{station.name}}</v-card-subtitle>

    <v-card-text>
      <div>{{station.address}}</div>
      <div>{{station.phone}}</div>
    </v-card-text>

    <v-card-actions>
      <v-spacer/>
      <v-btn
        text
        :to="{name: 'book/period', params: {stid: station.stationID}}"
      >
        予約する
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'CStationCard',
  props: {
    station: {
      type: Object,
      required: true
    }
  }
}
</script>

<!--

    <ul>
      <li>
        <router-link
          :to="{name: 'book/period', params: {stid: 11500}}"
          v-text="'次へ'"
        />
      </li>
    </ul>
-->
